// Icons for timeline activity events (tooltip + legend). Comment events vary their icon by
// CommentType so a general comment, a request, a revision request, and a response each read
// differently at a glance. commentType values are the CommentType enum names the backend sends.

export const eventIcon = (type: string, commentType?: string | null): string => {
    if (type === 'File') return 'dx-icon-attach';
    if (type === 'Note') return 'dx-icon-edit';
    // Comment
    switch (commentType) {
        case 'Request': return 'dx-icon-help';
        case 'RequestRevision': return 'dx-icon-revert';
        case 'Response': return 'dx-icon-message';
        default: return 'dx-icon-comment';
    }
};
